import {AuthInputsLayout} from '../../ui/layouts/auth';
import {Button} from '../../ui/atoms/button';
import {TextField} from '../../ui/molecules/field/textfield';
import {VerticalSpacer} from '../../ui/atoms/spacer';
import {PasswordInputToggle} from '../../ui/molecules/password-input-toggle';

import React, {memo} from 'react';
import {useAdminSignInHook} from './sign-in-hooks';
import {SignInFormData} from './sign-in-interface';
import {Body2} from '../../ui/atoms/typography/body2';
import {Link} from '../../ui/atoms/link';
import {GoogleIcon} from '../../ui/atoms/icons';
import GoogleLogin from 'react-google-login';
import {useAdminProfileHook} from '../admin/admin-profile/admin-profile-hooks';

export const AdminSignInForm = memo(
  ({onSubmit}: {onSubmit: (data: SignInFormData) => Promise<void>}) => {
    const {
      isSubmitting,
      handleSubmit,
      submitForm,
      register,
      errors,
      isDisabled,
    } = useAdminSignInHook(onSubmit);

    const {authGoogle} = useAdminProfileHook(onSubmit);

    const googleClientId = process.env.REACT_APP_GOOGLE_CLIENT_ID || '';

    return (
      <form method="post" onSubmit={handleSubmit(submitForm)}>
        <AuthInputsLayout feature="signup">
          <TextField
            placeholder="Email"
            defaultValue=""
            type="text"
            autoFocus
            ref={register}
            helper={errors.email?.message || ''}
            state={errors.email ? 'error' : 'default'}
            name="email"
          />
          <TextField
            placeholder="Password"
            type="password"
            ref={register}
            helper={errors.password?.message || ''}
            state={errors.password ? 'error' : 'default'}
            name="password"
            action={(ref) => <PasswordInputToggle inputRef={ref} />}
          />

          <Button
            width="full"
            type="submit"
            disabled={isDisabled}
            data-form-action={true}
            isLoading={isSubmitting}
            aria-busy={isSubmitting}>
            Login
          </Button>
          <VerticalSpacer size="16px" />
          <Body2 align="center" kind="blue300">
            <Link to="/forgot-password">Forgot Password</Link>
          </Body2>
          <VerticalSpacer size="16px" />

          <GoogleLogin
            clientId={googleClientId}
            render={(renderProps) => (
              <Button
                width="full"
                type="button"
                kind="secondary"
                className="flex items-center justify-center h-[56px] overflow-hidden"
                aria-busy={isSubmitting}
                disabled={renderProps.disabled}
                onClick={renderProps.onClick}>
                <GoogleIcon /> &nbsp; Sign in with Google
              </Button>
            )}
            buttonText="Login"
            onSuccess={authGoogle}
            onFailure={authGoogle}
            cookiePolicy={'single_host_origin'}
          />
        </AuthInputsLayout>
      </form>
    );
  },
);

AdminSignInForm.displayName = 'AdminSignIn';
